import { useTranslation } from 'react-i18next';

import { SetupPaymentOptionCard } from '@/components/setup/experience/SetupPaymentProcessorCard';
import type { SetupLivePayment } from '@/components/setup/experience/lib/setupPaymentUtils';
import type { TagadapayApply } from '@/hooks/use-tagadapay-apply';

type Props = {
  livePayment: SetupLivePayment;
  application: TagadapayApply;
  logoSrc?: string;
  isSelected: boolean;
  isRecommended: boolean;
  activeChip: string | null;
  disabled: boolean;
  onSelect: () => void;
};

export function SetupPaymentLiveCard({ livePayment, application, ...cardProps }: Props): React.JSX.Element {
  const { t } = useTranslation(['setup', 'processors']);
  const isUnavailable = livePayment.kind === 'unavailable';

  return (
    <SetupPaymentOptionCard
      {...cardProps}
      title={t('experience.payment.cards.tagadapay.title')}
      description={
        isUnavailable
          ? t(`processors:tagadapayApply.${application.intent}Title`)
          : t('experience.payment.cards.tagadapay.description')
      }
    >
      {isUnavailable && (
        <div className="text-muted-foreground px-5 pb-1 pt-3 text-sm">
          <p className="m-0">{t(`processors:tagadapayApply.${application.intent}Body`)}</p>
          <a
            className="text-primary mt-2 inline-flex underline underline-offset-4"
            href={application.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t(`processors:tagadapayApply.${application.intent}Cta`)}
          </a>
        </div>
      )}
    </SetupPaymentOptionCard>
  );
}
